import * as extendUtils from '../../../utils/object/extend.utils';
import {baseStagingConfig} from '../base/staging.config';
import {PrismConfigOptions} from '../environment-variables.interface';
import {cbsnewsDecoStagingConfig} from './staging.deco.config';

export const cbsnewsStagingConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseStagingConfig, cbsnewsDecoStagingConfig, {
  environmentName: "Cbs News Staging Environment",
  hubApi: 'https://stage-cms.cbsnews.com',
  ionicEnvName: 'staging',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbsnews/staging.config.ts